module.exports = __webpack_public_path__ + "img/twitter.c99c8f5a.svg";